// ADR 28.9.26d §1 — Material's inverse-surface snackbar, drawn once for the
// queue's entries and for `UpdateToast`, which shares the look but not the
// queue. Presentational: what the message says to assistive technology is the
// caller's decision (the host speaks through its own live region; the toast
// keeps its `role="status"`).
//
// The 4px corner is M3 `extraSmall`; `ink` and `surface` are the inverse pair
// in both themes. `accent-soft` on the action is the nearest token to M3
// `inversePrimary` (28.9.26b TBD 1 is not decided here).

import type { ReactNode } from 'react'

import { Button } from '../Button'

export interface SnackbarSurfaceProps {
  children: ReactNode
  action?: { label: string; onPress: () => void }
}

export function SnackbarSurface({ children, action }: SnackbarSurfaceProps) {
  return (
    <div className="flex min-h-12 items-center gap-3 rounded bg-ink px-4 py-2 text-surface shadow-2 motion-safe:animate-reveal">
      <div className="flex-1 text-body-md">{children}</div>
      {action ? (
        <Button
          variant="ghost"
          className="!text-accent-soft !no-underline font-medium hover:!bg-surface/10"
          onClick={action.onPress}
        >
          {action.label}
        </Button>
      ) : null}
    </div>
  )
}
